<template>
  <div
    v-if="status === 'AVAILABLE'"
    key="available"
    class="card-row available"
  >
    <div class="status">
      <div class="status-header positive">
        <icon
          icon="check-circle-solid"
          size="sm"
        />
        <span>Glasvezel is beschikbaar</span>
      </div>

      <p>{{ networkMessage }}</p>
    </div>
    <a
      class="btn primary"
      role="button"
      :href="url"
    >
      <span class="label">Vergelijk glasvezelpakketten</span>
      <Icon
        icon="long-arrow-right"
        size="sm"
      />
    </a>
  </div>
  <!--  Glasvezel staat op de planning-->
  <div
    v-else
    key="notAvailable"
    class="card-row"
  >
    <div
      v-if="!subscribeStatus"
      class="status"
    >
      <div 
        v-if="status === 'PLANNED'" 
        class="status-header semi-positive">
        <icon
          icon="exclamation-circle-solid"
          size="sm"
        />
        <span>Glasvezel wordt binnenkort aangelegd</span>
      </div>
      <div 
        v-else 
        class="status-header negative">
        <icon
          icon="times-circle-solid"
          size="sm"
        />
        <span>Glasvezel is nog niet beschikbaar</span>
      </div>
      <!-- <p v-if="status === 'PLANNED' && fiber_plan_date">
        Binnenkort is glasvezelinternet beschikbaar op jouw adres, rond {{ fiber_plan_date }} begint de aanleg. Meteen op de hoogte blijven zodra je kan vergelijken? Vul dan hieronder je e-mailadres in. Dan hoor je van ons wanneer het zover is.
      </p> -->
      <p v-if="status === 'PLANNED'">
        Binnenkort is glasvezel internet beschikbaar op jouw adres. Meteen op de hoogte blijven zodra je kan vergelijken? Vul dan hieronder je mail adres in. Dan hoor je van ons wanneer het zover is.
      </p>
      <p v-else>
        Helaas, glasvezel internet is nog niet beschikbaar op jouw adres. Wil je op de hoogte blijven van de aanleg? Vul dan hieronder je mail adres in. Dan hoor je van ons wanneer het zover is.
      </p>
    </div>
    <div
      v-if="!subscribeStatus"
      class="email-input"
    >
      <TextInput
        id="fc-first-name"
        v-model.lazy="firstName"
        label="Voornaam"
      />

      <TextInput
        id="fc-email"
        v-model="email"
        v-model:error="fieldError"
        label="E-mailadres"
      />
      <button
        class="btn primary subscribe-button"
        @click="subscribe()"
      >
        Houd mij op de hoogte
      </button>
    </div>
    <div
      v-show="subscribeStatus"
      key="emailSucces"
      class="emailSucces"
    >
      <div class="status">
        <div class="status-header positive">
          <icon
            icon="check-circle-solid"
            size="sm"
          />
          <span>Aanmelden gelukt</span>
        </div>
        <p>Je bent succesvol aangemeld voor de glasvezel notificaties op het volgende e-mailadres:</p>
      </div>
      <div class="result-email-input">
        <span class="result email">{{ email }}</span>
      </div>
      <div v-if="fiberCheckCaption" class="caption">
        <div v-html="fiberCheckCaption" class="caption-text"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import TextInput from 'vue-elements/input/TextInput.vue';
import { ref, computed } from 'vue';
import {
    validateEmail,
} from '../../../../assets/js/helpers/validator';
import Icon from '../../../../abstracts/elements/icon/Icon.vue';
import { mijnKeuzeApiURL } from '../../../../assets/js/variables/api';

const props = defineProps({
    status: {
        type: String,
        default: '',
    },
    provider: {
        type: String,
        default: '',
    },
    plannedDate: {
        type: String,
        default: '',
    },
    location: {
        type: Object,
        default: () => null,
    },
    url: {
        type: String,
        default: '',
    },
    fiberCheckCaption: {
        type: String,
        default: '',
    },
});

const firstName = ref('');
const email = ref('');
const fieldError = ref(null);
const subscribeStatus = ref(false);
const requestActive = ref(false);

const networkMessage = computed(() => {
  const networkMap = {
    'delta-fiber': 'het Delta Netwerk',
    'caiway': 'het Delta Netwerk',
    'gop': 'het KPN Netwerk',
    'god': 'het KPN Netwerk',
    'eof': 'het KPN Netwerk',
    'vwt': 'het Open Dutch Fiber netwerk',
    'jonaz': 'het Jonaz netwerk'
  };

  const network = networkMap[props.provider] || '';

  if (network) {
    return `Yes! Je hebt glasvezel van ${network}. Bekijk welke pakketten je kunt afnemen.`;
  } else {
    return 'Yes! Je hebt glasvezel. Bekijk welke pakketten je kunt afnemen.';
  }
});

const subscribe = () => {
    if (!validateEmail(email.value)) {
        fieldError.value = 'Vul een geldig e-mailadres in.';
        return;
    }
    if (!requestActive.value) {
        requestActive.value = true;
        fetch(`${mijnKeuzeApiURL()}/v1/alert/fiber-check/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                first_name: firstName.value.trim(),
                email_address: email.value.trim(),
                postal_code: props.location.postCode.trim(),
                number: props.location.number.trim(),
                number_extension: props.location.numberExtension?.trim(),
            }),
        })
            .then((response) => (response.ok ? Promise.resolve(response.json()) : Promise.reject(response)))
            .then((result) => {
                subscribeStatus.value = result.success;
            })
            .catch(() => {
                fieldError.value = 'Vul een geldig E-mailadres in.';
            })
            .finally(() => {
                requestActive.value = false;
            });
    }
};

</script>
